const designTypesTools = {
    adapt: function () {
        if ($('.js_design-types__wrapper').length) {
            $('.js_design-types__wrapper').each((i, el) => {
                const big = $(el).find('.js_design-types__img_big')
                const small = $(el).find('.js_design-types__img_small')
                const bigHeigth = big.outerHeight()
                small.css('height', bigHeigth)
            })
        }
    }
}

$(document).ready(() => {
    designTypesTools.adapt()
})

$(window).on('resize', function () {
    designTypesTools.adapt()
})